import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function RatingForm({ orderId, otherName, role, onDone }) {
  const [score, setScore] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!score) {
      toast.error("Seleziona almeno una stella");
      return;
    }
    setBusy(true);
    try {
      await api.post("/ratings", {
        order_id: orderId,
        score,
        comment: comment.trim() || null,
      });
      toast.success("Grazie per la tua valutazione!");
      onDone && onDone();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message || "Errore invio valutazione");
    } finally {
      setBusy(false);
    }
  };

  const display = hover || score;

  return (
    <div className="card-soft p-5 sm:p-6 space-y-4" data-testid="rating-form">
      <div>
        <p className="overline">Valuta {role === "customer" ? "il trasportatore" : "il cliente"}</p>
        <h3 className="font-display text-lg font-bold tracking-tight mt-0.5">
          {otherName || "Esperienza"}
        </h3>
      </div>

      <div className="flex items-center gap-2" data-testid="rating-stars">
        <div className="flex gap-1">
          {[1, 2, 3, 4, 5].map((n) => {
            const active = display >= n;
            return (
              <button
                key={n}
                type="button"
                onClick={() => setScore(n)}
                onMouseEnter={() => setHover(n)}
                onMouseLeave={() => setHover(0)}
                data-testid={`rating-star-${n}`}
                aria-label={`${n} stelle`}
                className="p-1 transition-transform hover:scale-110 active:scale-95"
              >
                <Star
                  className={`h-8 w-8 transition ${
                    active ? "fill-yellow-400 text-yellow-400" : "text-zinc-300"
                  }`}
                />
              </button>
            );
          })}
        </div>
      </div>

      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        rows={2}
        maxLength={500}
        placeholder="Lascia un commento (opzionale)"
        data-testid="rating-comment"
        className="w-full rounded-xl border border-dapnow-line p-3 text-sm focus:border-dapnow-blue focus:ring-2 focus:ring-dapnow-blue/20 outline-none resize-none"
      />

      <button
        onClick={submit}
        disabled={!score || busy}
        data-testid="rating-submit-btn"
        className="btn-primary w-full"
      >
        {busy ? "Invio…" : score ? `Invia valutazione (${score}/5)` : "Seleziona una valutazione"}
      </button>
    </div>
  );
}
